const version = '1.3.36' ;

export default version ;